export const ActualScanToPackageStateTranslationKeyMapping = {
    BETWEEN_STATIONS : "commons.in_transit_(ds_->_ds)",
    SORT : "commons.stowed",
    DELIVERED : "commons.delivered",
    DELIVERY_ATTEMPTED : "commons.delivery_failed",
    REJECTED : "commons.delivery_rejected",
    DIVERT_FAILED : "commons.drop_failed",
    DIVERTED : "commons.dropped",
    SIDELINED : "commons.sidelined",
    HOLD_FOR_CUSTOMER_REQUEST : "commons.held",
    HELD: "commons.held",
    MANIFEST : "commons.manifested_(fc_->_ds)",
    DEPART : "commons.in_transit_(ds_->_customer)",
    INDUCT : "commons.inducted",
    INDUCT_PENDING : "commons.induct_pending",
    LOST : "commons.marked_as_lost",
    MISSING : "commons.marked_as_missing",
    DELAYED_AT_STATION : "commons.marked_for_reprocess",
    CASH_IN_ASSOCIATE: "commons.cash_in_associate",
    PICKED : "commons.picked",
    RECEIVED: "commons.received",
    DELAYED : "commons.pickup_failed",
    HOLD_FOR_REDELIVERY : "commons.received_(ds_->_customer)",
    READY_FOR_FC_RETURN : "commons.received_(ds_->_fc)",
    RTS_RECEIVED_TO_DS : "commons.rts_received_(ds_->_customer)",
    ARRIVED : "commons.arrived",
    READY_FOR_TRANSFER : "commons.staged_(ds_->_ds)",
    STAGED : "commons.staged",
    STAGE: "commons.staged_(ds_->_customer)",
    NEEDS_ATTENTION : "commons.problem_solve",
    PICKED_UP : "commons.in_transit_(seller/locker_->_ds)",
    DEPARTED_FOR_FC : "commons.in_transit_(ds_->_fc/seller)",
    SORTED_FOR_FC : "commons.stowed_(ds_->_fc)",
    AT_WRONG_STATION : "commons.problem_solve",
    WRONG_NODE : "commons.problem_solve",
    INDUCTED : "commons.inducted",
    OUT_FOR_DELIVERY : "commons.in_transit_(ds_->_customer)",
    PROBLEM_SOLVE : "commons.problem_solve",
    HOLD_FOR_ACTION : "commons.problem_solve",
    DEPARTED : "commons.in_transit_(ds_->_customer)",
    IN_TRANSIT_TO_STORE: "commons.in_transit_(ds_->_store)",
    DROPPED_AT_STORE: "commons.received_(store_->_customer)",
    UNSUCCESSFUL_AT_STORE: "commons.delivery_failed",
    DROPPED_AT_ORDT: "commons.received_(ordt_->_customer)",
    PICKUP_DONE : "commons.in_transit_(customer/locker_->_ds)",
    PENDING_PICKUP : "commons.manifested_(seller/locker_->_ds)",
    PENDING_RETURN_PICKUP: "commons.manifested_(customer_->_ds)",
    MANIFEST_CANCELLED: "commons.manifest_cancelled",
    MFN_CANCELLED: "commons.manifest_cancelled",
    MFN_PICKUP_DONE : "commons.in_transit_(seller_->_ds)",
    IN_TRANSIT_TO_DS : "commons.in_transit_(fc_->_ds)",
    IN_TRANSIT_DS_TO_DS: "commons.in_transit_(ds_->_ds)",
    IN_TRANSIT_TO_CUSTOMER: "commons.in_transit_(ds_->_customer)",
    IN_TRANSIT_DS_TO_FC: "commons.in_transit_(ds_->_fc)",
    IN_TRANSIT_CUSTOMER_TO_DS: "commons.in_transit_(customer/locker_->_ds)",
    PICKUP_FAILED: "commons.pickup_failed",
    MARKED_AS_LOST: "commons.marked_as_lost",
    DISPUTED_SCAN: "commons.disputed_scan",
    PENDING_DROPOFF : "commons.manifested_(seller_dropoff)",
    RTS_PENDING_VERIFICATION: "commons.rts_pending_verification_(ds_->_fc)"
}

export const PackageStatesTranslationKeyMap = {
    ARRIVED: "commons.arrived",
    MANIFESTED: "commons.manifested",
    STOW_BUFFERED: "commons.stow_buffered",
    JACKPOT_BUFFERED: "commons.jackpot_buffered",
    STOWED: "commons.stowed",
    PICKED: "commons.picked",
    STAGED: "commons.staged",
    READY_FOR_DRIVER_PICKUP: "commons.ready_for_driver_pickup",
    MARKED_FOR_PROBLEM: "commons.marked_for_problem",
    IN_TRANSIT: "commons.in_transit",
    READY_FOR_TRANSIT: "commons.ready_for_transit",
    INDUCTED: "commons.inducted",
    RECEIVED: "commons.receivedV2",
    HELD: "commons.held",
    TRANSIT_REQUIRED:"commons.transit_required",
    MARKED_FOR_REPROCESS: "commons.marked_for_reprocess",
    MARKED_AS_LOST: "commons.marked_as_lost",
    MARKED_AS_MISSING: "commons.marked_as_missing",
    PICKED_FROM_BUFFER: "commons.picked_from_buffer",
    STAGE_BUFFERED: "commons.stage_buffered",
    DELIVERED: "commons.delivered",
    PARTIALLY_DELIVERED: "commons.partially_delivered",
    DELIVERY_FAILED: "commons.delivery_failed",
    PICKUP_FAILED:"commons.pickup_failed",
    DROPPED: "commons.dropped",
    DROP_FAILED:"commons.drop_failed",
    DELIVERY_REJECTED: "commons.delivery_rejected",
    DISPOSED: "commons.removed",
    RETURNED_TO_SELLER: "commons.returned_to_seller"
}


// WEBPACK FOOTER //
// ./src/commons/dataStore/TranslationsMapping.js